'use strict';

var React = require('react');

const parseFieldHandle = (field)=>{
    var _exec;
    const fieldHandle = field ? ((_exec = /{field:(.*)}/.exec(field)) == null ? void 0 : _exec[1]) || '' : '';
    return fieldHandle;
};
const parseFieldCondition = (condition)=>{
    try {
        const maybeCondition = condition && typeof condition === 'string' ? JSON.parse(condition) : null;
        if (!maybeCondition) {
            return null;
        }
        const maybeConditions = Array.isArray(maybeCondition.conditions) ? maybeCondition.conditions : [];
        const fieldCondition = {
            showRule: maybeCondition.showRule === 'show' ? 'show' : 'hide',
            conditionRule: maybeCondition.conditionRule === 'all' ? 'all' : 'any',
            conditions: maybeConditions.map((condition)=>{
                return {
                    id: condition.id,
                    field: parseFieldHandle(condition.field),
                    condition: condition.condition,
                    value: condition.value
                };
            })
        };
        return fieldCondition;
    } catch (e) {
        console.error('Error parsing condition', condition);
        return null;
    }
};
const isFormValue = (value)=>{
    return typeof value === 'string' || Array.isArray(value);
};
const isRecord = (value)=>{
    return typeof value === 'object' && value !== null;
};
const extractFieldValue = (path, formValues)=>{
    const keys = path.split('.');
    let value = '';
    keys.reduce((acc, key, i)=>{
        if (!isRecord(acc)) return undefined;
        const isLastKey = i === keys.length - 1;
        const thisValue = acc[key];
        if (isLastKey && isFormValue(thisValue)) {
            value = thisValue;
            return thisValue;
        }
        return acc[key];
    }, formValues);
    return value;
};
const testCondition = (condition, formValues)=>{
    const fieldValue = extractFieldValue(condition.field, formValues);
    const fieldValueArr = Array.isArray(fieldValue) ? fieldValue : [
        fieldValue
    ];
    const fieldValueStrArr = fieldValueArr.map((value)=>value.toString());
    const value = typeof condition.value === 'string' ? condition.value : '';
    const numberValue = parseFloat(value);
    const fieldValueFloat = typeof fieldValue === 'string' ? parseFloat(fieldValue) : 0;
    switch(condition.condition){
        case '=':
            // console.log('fieldValue', fieldValue, '=', value);
            return fieldValue === value;
        case '!=':
            // console.log('fieldValue', fieldValue, '!=', value);
            return fieldValue !== value;
        case '>':
            // console.log('fieldValue', fieldValueFloat, '>', numberValue);
            return fieldValueFloat > numberValue;
        case '<':
            // console.log('fieldValue', fieldValueFloat, '<', numberValue);
            return fieldValueFloat < numberValue;
        case 'contains':
            // console.log('fieldValue', fieldValueStrArr, 'contains', value);
            return fieldValueStrArr.includes(value) || !!fieldValueStrArr.find((v)=>v.toLowerCase().includes(value.toLowerCase()));
        case 'startsWith':
            // console.log('fieldValue', fieldValueStrArr, 'startsWith', value);
            return !!fieldValueStrArr.find((v)=>v.toLowerCase().startsWith(value.toLowerCase()));
        case 'endsWith':
            // console.log('fieldValue', fieldValueStrArr, 'endsWith', value);
            return !!fieldValueStrArr.find((v)=>v.toLowerCase().endsWith(value.toLowerCase()));
        default:
            console.error('Unknown condition', condition);
            return false;
    }
};
function useFieldConditions(field, methods) {
    const conditionString = field == null ? void 0 : field.conditions;
    const enabled = !!(field == null ? void 0 : field.enableConditions);
    const fieldCondition = React.useMemo(()=>parseFieldCondition(conditionString || ''), [
        conditionString
    ]);
    if (!fieldCondition || !enabled || !methods) {
        return true;
    }
    const formValues = methods.watch();
    const { conditions, conditionRule } = fieldCondition;
    if (conditions.length === 0) {
        return true;
    }
    const conditionResults = conditions.map((condition)=>testCondition(condition, formValues));
    // console.log('formValues', formValues, 'conditionResults', conditionResults);
    if (conditionRule === 'all') {
        return conditionResults.every((result)=>result);
    }
    return conditionResults.some((result)=>result);
}

module.exports = useFieldConditions;
